<form [formGroup]="form">
    <div class="flex flex-row justify-between space-x-4 mt-8">
        <app-input label="CSOS Number"
            formControlName="csos"
            [autofocus]="true"
        ></app-input>
        <app-input label="PO Number"
            formControlName="poNumber"
        ></app-input>
        <app-input label="Invoice Number"
            formControlName="invoiceNumber"
        ></app-input>
        <app-datepicker-input label="Ship Date"
            formControlName="shipDate"
            iconName="icon-date-picker"
            [initialValue]="initialValue?.shipDate"
            [dateMax]="now()"
            (inputTabKeyDown)="supplierBuyerDetails.focusInput()"
        ></app-datepicker-input>
    </div>
    <app-supplier-buyer-sale-details class="block pt-6"
        [supplier]="initialValue?.supplierDetails"
        [buyer]="initialValue?.buyerDetails"
        (currentSupplierChanged)="setSupplier($event)"
        (currentBuyerChanged)="setBuyer($event)"
        [pharmacyIsSupplier]="false"
        #supplierBuyerDetails
    >
    </app-supplier-buyer-sale-details>
</form>
